// src/data/barMenuData.js

import { deriveMenuCocktails } from './customCocktails';

export const ingredientIcons = {
  // Spirits
  "ジン": "🍸", "ウォッカ": "🧊", "ラム": "🏴‍☠️", "テキーラ": "🌵", "ウイスキー": "🥃", "バーボン": "🥃",
  "スコッチウイスキー": "🥃", "ライウイスキー": "🥃", "ブランデー": "🍇", "アップルブランデー": "🍎", "コニャック": "🍇", "アブサン": "🧪",

  // Liqueurs
  "カシスリキュール": "💜", "ピーチリキュール": "🍑", "カンパリ": "🔴", "アマレット": "🌰", "コアントロー": "🍊",
  "ホワイトキュラソー": "🍊", "ブルーキュラソー": "💙", "ライチリキュール": "🌸", "マリブリキュール": "🥥",
  "チェリーブランデー": "🍒", "ドライベルモット": "🌿", "スイートベルモット": "🍷", "クレームドカシス": "💜",
  "オレンジキュラソー": "🍊", "アペロール": "🟠", "アマーロ・ノニーノ": "🟤", "グリーンティーリキュール": "🍵",

  // Mixers
  "トニックウォーター": "💧", "ソーダ": "✨", "コーラ": "⚫️", "ジンジャーエール": "🔶", "オレンジジュース": "🍊", "ミルク": "🥛",
  "レモンジュース": "🍋", "ライムジュース": "🟢", "グレープフルーツジュース": "💖", "パイナップルジュース": "🍍",
  "トマトジュース": "🍅", "クランベリージュース": "❤️", "レモネード": "🍋✨",

  // Others
  "ビール": "🍺", "赤ワイン": "🍷", "白ワイン": "🥂", "砂糖": "🍬", "角砂糖": "🍬", "砂糖シロップ": "🍯", "塩": "🧂", "コショウ": "⚫️", "グレナデンシロップ": "🌹",
  "アンゴスチュラビターズ": "💧", "ライム": "🟢", "レモン": "🍋", "マカダミアナッツ": "🌰", "チーズ": "🧀",
  "ベーコン": "🥓", "ハチミツ": "🍯", "ローズマリー": "🌿", "ガーリック": "🧄", "バジル": "🌿",
  "ココナッツ": "🥥", "ローストバナナ": "🍌", "野菜": "🥕", "ドライフルーツ": "🍇", "チョコレート": "🍫",
  "オリーブ": "🫒", "鶏肉": "🍗", "トリュフ": "🟫", "生ハム": "🥓", "サラミ": "🥩",
  "ピーチ": "",
  "マンゴー": "",
  "ヨーグルト": "",
  "ミント": "",
  "default": "❓"
};

export const menuData = {
  fingerFood: [
    { name: "Finger Food", items: [
        { name: "ミックスナッツ", price: 500, ingredients: ["マカダミアナッツ"] },
        { name: "燻製ミックスナッツ", price: 800, ingredients: ["マカダミアナッツ", "ベーコン"] },
        { name: "オリーブ", price: 500, ingredients: ["オリーブ"] },
        { name: "鶏むねのジャーキー", price: 600, ingredients: ["鶏肉"] },
        { name: "ピクルス盛り合わせ", price: 600, ingredients: ["野菜"] },
        { name: "トリュフチョコレート", price: 900, ingredients: ["チョコレート", "トリュフ"] },
        { name: "ドライフルーツ盛り合わせ", price: 900, ingredients: ["ドライフルーツ"] },
        { name: "生ハムとサラミの盛り合わせ", price: 900, ingredients: ["生ハム", "サラミ"] },
        { name: "チーズの盛り合わせ", price: 900, ingredients: ["チーズ"] }
    ] }
  ],
  todaysSpecials: [
    { name: "本日のメイン", price: 1800, description: "", ingredients: [], glass: "" },
    { name: "本日のカレー", price: 1400, description: "", ingredients: [], glass: "" },
    { name: "本日のパスタ", price: 1600, description: "", ingredients: [], glass: "" }
  ],
  drinks: {
    beer: [
      { name: "ハイネケン", price: 700, glass: "🍺", ingredients: ["ビール"] },
      { name: "ギネス", price: 800, glass: "🍺", ingredients: ["ビール"] },
      { name: "コロナ", price: 800, glass: "🍺", ingredients: ["ビール"] },
      { name: "キリン グリーンズフリー", price: 600, glass: "🍺", ingredients: ["ビール"] }
    ],
    wine: [
      { name: "グラスワイン 赤・白", price: 700, glass: "🍷", ingredients: ["赤ワイン", "白ワイン"] },
      { name: "グラススパークリングワイン", price: 800, glass: "🥂", ingredients: ["白ワイン"] },
      { name: "ボトルワイン", price: "3,800~", glass: "🍾", ingredients: ["赤ワイン", "白ワイン"] },
      { name: "ボトルスパークリングワイン", price: "4,500~", glass: "🍾", ingredients: ["白ワイン"] }
    ],
    brandy: [
      { name: "カルヴァドス マスネ ポム プリゾニエール", price: 1200, glass: "🥃", ingredients: ["アップルブランデー"] },
      { name: "レミーマルタン VSOP", price: 1500, glass: "🥃", ingredients: ["ブランデー", "コニャック"] },
      { name: "ポールジロー トラディショナル", price: 1600, glass: "🥃", ingredients: ["ブランデー", "コニャック"] },
      { name: "ヘネシー VSOP", price: 2000, glass: "🥃", ingredients: ["ブランデー", "コニャック"] }
    ],
    rum: [
      { name: "バカルディ", price: 700, glass: "🥃", ingredients: ["ラム"] },
      { name: "マイヤーズ", price: 700, glass: "🥃", ingredients: ["ラム"] },
      { name: "コルバ マイセラ", price: 800, glass: "🥃", ingredients: ["ラム"] },
      { name: "キャプテンモルガン", price: 800, glass: "🥃", ingredients: ["ラム"] },
      { name: "ロンサカパ", price: 1300, glass: "🥃", ingredients: ["ラム"] }
    ],
    tequila: [
      { name: "クエルボ シルバー", price: 700, glass: "🥃", ingredients: ["テキーラ"] },
      { name: "クエルボ ゴールド", price: 800, glass: "🥃", ingredients: ["テキーラ"] },
      { name: "クエルボ 1800 レポサド", price: 1000, glass: "🥃", ingredients: ["テキーラ"] },
      { name: "ドンフリオ レポサド", price: 1300, glass: "🥃", ingredients: ["テキーラ"] },
      { name: "パトロン アネホ", price: 1500, glass: "🥃", ingredients: ["テキーラ"] }
    ],
    shochu: {
      title: "Shochu",
      types: [
        { type: "芋 (Imo)", items: [ { name: "黒霧島", price: 600, glass: "🍶" }, { name: "明るい農村", price: 700, glass: "🍶" }, { name: "天使の誘惑", price: 1000, glass: "🍶" } ] },
        { type: "麦 (Mugi)", items: [ { name: "いいちこ", price: 600, glass: "🍶" }, { name: "佐藤", price: 800, glass: "🍶" }, { name: "兼八", price: 900, glass: "🍶" } ] },
        { type: "米 (Kome)", items: [ { name: "白岳しろ", price: 600, glass: "🍶" }, { name: "鳥飼", price: 800, glass: "🍶" } ] },
        { type: "黒糖 (Kokuto)", items: [ { name: "奄美の杜", price: 700, glass: "🍶" } ] }
      ],
      options: [ { name: "割りもの", price: "+100" }, { name: "濃いめ", price: "+200" } ]
    },
    spirits: {
      gin: [
        { name: "ビーフィーター", price: 700, glass: "🥃", ingredients: ["ジン"] },
        { name: "ボンベイサファイア", price: 800, glass: "🥃", ingredients: ["ジン"] },
        { name: "タンカレーNo.10", price: 1100, glass: "🥃", ingredients: ["ジン"] },
        { name: "ヘンドリックス", price: 1100, glass: "🥃", ingredients: ["ジン"] },
        { name: "モンキー47", price: 1500, glass: "🥃", ingredients: ["ジン"] }
      ],
      vodka: [
        { name: "ストリチナヤ", price: 700, glass: "🥃", ingredients: ["ウォッカ"] },
        { name: "ズブロッカ", price: 800, glass: "🥃", ingredients: ["ウォッカ"] },
        { name: "アブソルート ライム", price: 850, glass: "🥃", ingredients: ["ウォッカ", "ライム"] },
        { name: "グレイグース", price: 1100, glass: "🥃", ingredients: ["ウォッカ"] }
      ]
    },
    whisky: {
      bourbon: [
        { name: "ジムビーム", price: 700, glass: "🥃", ingredients: ["バーボン"] },
        { name: "フォアローゼズ", price: 700, glass: "🥃", ingredients: ["バーボン"] },
        { name: "オールドクロウ", price: 700, glass: "🥃", ingredients: ["バーボン"] },
        { name: "ワイルドターキー", price: 800, glass: "🥃", ingredients: ["バーボン"] },
        { name: "メーカーズマーク", price: 800, glass: "🥃", ingredients: ["バーボン"] },
        { name: "I.W.ハーパー", price: 800, glass: "🥃", ingredients: ["バーボン"] },
        { name: "ジャックダニエル", price: 900, glass: "🥃", ingredients: ["バーボン"] },
        { name: "オールドグランダッド", price: 900, glass: "🥃", ingredients: ["バーボン"] },
        { name: "ワイルドターキー8年", price: 1000, glass: "🥃", ingredients: ["バーボン"] },
        { name: "ブッカーズ", price: 1000, glass: "🥃", ingredients: ["バーボン"] }
      ],
      scotch: [
        { name: "バランタインファイネスト", price: 700, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "バランタイン10年", price: 900, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "グレンモーレンジ10年", price: 900, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "シーバスリーガル12年", price: 900, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "グレンフィディック12年", price: 1100, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "ボウモア12年", price: 1300, glass: "🥃", ingredients: ["スコッチウイスキー"] },
        { name: "アードベック10年", price: 1300, glass: ["スコッチウイスキー"] },
        { name: "ラフロイグ10年", price: 1500, glass: ["スコッチウイスキー"] },
        { name: "マッカラン12年", price: 1900, glass: ["スコッチウイスキー"] }
      ],
      canadian: [
        { name: "カナディアンクラブ", price: 700, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "クラウンロイヤル", price: 900, glass: "🥃", ingredients: ["ウイスキー"] }
      ],
      irish: [
        { name: "ブッシュミルズ", price: 800, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "ジェムソン", price: 800, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "バスカー", price: 900, glass: "🥃", ingredients: ["ウイスキー"] }
      ],
      japanese: [
        { name: "知多", price: 1400, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "碧", price: 1400, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "富士", price: 1400, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "イチローズモルト ホワイト", price: 1400, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "宮城峡", price: 1600, glass: "🥃", ingredients: ["ウイスキー"] },
        { name: "白州", price: 1800, glass: "🥃", ingredients: ["ウイスキー"] }
      ],
      options: [ { name: "割りもの", price: "+100" }, { name: "濃いめ", price: "+300" } ]
    },
    softDrink: [
      { name: "コカコーラ", price: 600, glass: "🥤", ingredients: ["コーラ"] },
      { name: "ジンジャーエール", price: 600, glass: "🥤", ingredients: ["ジンジャーエール"] },
      { name: "トニックウォーター", price: 600, glass: "🥤", ingredients: ["トニックウォーター"] },
      { name: "オレンジジュース", price: 600, glass: "🥤", ingredients: ["オレンジジュース"] },
      { name: "グレープフルーツジュース", price: 600, glass: "🥤", ingredients: ["グレープフルーツジュース"] },
      { name: "クランベリージュース", price: 600, glass: "🥤", ingredients: ["クランベリージュース"] },
      { name: "パイナップルジュース", price: 600, glass: "🥤", ingredients: ["パイナップルジュース"] },
      { name: "トマトジュース", price: 600, glass: "🥤", ingredients: ["トマトジュース"] },
      { name: "烏龍茶", price: 600, glass: "🥤" }
    ],
    cocktails: deriveMenuCocktails(),
    nonAlcoholic: [
      { name: "レモン スカッシュ", price: 750, description: "甘酸っぱい爽快感！さっぱりとした口当たりのレモンスカッシュ", ingredients: ["レモン", "ソーダ"], glass: "" },
      { name: "グレープフルーツ スカッシュ", price: 750, description: "グレナデンシロップとグレープフルーツのグラデーションが美しいモクテル", ingredients: ["グレープフルーツジュース", "グレナデンシロップ", "ソーダ"], glass: "" },
      { name: "ピーチ レモネード", price: 750, description: "桃とレモンとトニックウォーターを組み合わせた爽やかなレモネード", ingredients: ["ピーチ", "レモン", "トニックウォーター"], glass: "" },
      { name: "マンゴー ラッシー", price: 850, description: "マンゴーとヨーグルトのフレーバーを感じるラッシー お子さまにもおすすめです", ingredients: ["マンゴー", "ヨーグルト"], glass: "" },
      { name: "バージン ブリーズ", price: 750, description: "クランベリーとグレープフルーツのモクテル 優しい果実の酸味が感じられます", ingredients: ["クランベリージュース", "グレープフルーツジュース"], glass: "" },
      { name: "バージン メアリー", price: 850, description: "トマトジュースとオレンジジュースを組み合わせたヘルシーモクテル", ingredients: ["トマトジュース", "オレンジジュース"], glass: "" },
      { name: "ヴァージン モスコミュール", price: 750, description: "ドライジンジャーエールをベースにしたスパイシーモクテル", ingredients: ["ジンジャーエール", "ライム"], glass: "" },
      { name: "ヴァージン モヒート", price: 1000, description: "ミントとライムを使ったノンアルコールのモヒート 夏のビーチを思い出させてくれます", ingredients: ["ミント", "ライム", "ソーダ"], glass: "" }
    ]
  }
};